import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Services
import { UserService } from "@services/index.service";

// Interfaces
import { ResponseDataBase } from '@interfaces/index.interface';

// Constants
import { AppConstants } from '@app/appConstants';

declare var $: any; // TODO show modal in othe way

/** Página a la que lleva el enlace que se envia por mail */
@Component({
  selector: 'app-confirmmail',
  templateUrl: './confirmmail.page.html'
})
export class ConfirmmailComponent {
  confirmMailMessageSuccess: string;
  confirmMailMessageDanger: string;


  constructor(public _userService: UserService,
    public route: ActivatedRoute) {
    /** Cuando construimos la página directamente vamos a confirmar el mail */
    this.confirmMail();
  }

  /** El mail que se envia la usuario incluye con los parámetros necesarios, así que sacamos de ahí la información y la mandamos
   * al back. Si el usuario existe se le activa y sino se muestra error.
   */
  confirmMail() {
    let data;
    this.route.queryParams.subscribe(params => {
      data = params;
    });
    this._userService.setUserData('confirm', data).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.confirmMailMessageSuccess = 'EMAIL_CONFIRMED';
        this._userService.success = 'EMAIL_CONFIRMED';
      } else {
        this.confirmMailMessageDanger = response.METADATA.ERROR_MESSAGE
        this._userService.warning = response.METADATA.ERROR_MESSAGE
      }
      this._userService.loading = false;
      setTimeout(function () { $('#LoginModal').modal('show'); }, 2500);
      window.scrollTo(0, 0);
    });
  }
}
